import { Column, flexRender, Header, HeaderContext, SortDirection } from "@tanstack/react-table";
import { getFrozenColumnStyle, pinnedWidthOffset } from "./getTableStyles";
import { TableStyles_Types } from "../../../Definitions";
import { memo } from "react";
import { isObject } from "lodash";

export const HEADER_OR_FOOTER_KEY = {
	// eslint-disable-next-line no-unused-vars
	header: "header",
	// eslint-disable-next-line no-unused-vars
	footer: "footer"
} as const

type HeaderAndFooterKeys = typeof HEADER_OR_FOOTER_KEY[keyof typeof HEADER_OR_FOOTER_KEY]

interface HeaderBaseProps {
	headerOrFooterKey: HeaderAndFooterKeys;
	columnWidth: number[];
	tableStyle: TableStyles_Types;
	tableToggle?: boolean | number;
	loading?: boolean;
}

interface HeaderRowProps extends HeaderBaseProps {
	headers: Header<any, unknown>[]
}

interface HeadCellProps extends HeaderBaseProps { column: Column<any, unknown>; id: string; getContext: () => HeaderContext<any, unknown>; isSorted: false | SortDirection}

export const HeaderAndFooter = ({ headers, ...props}: HeaderRowProps) => {
	return headers.map(({column, id, getContext}) => {
		return (
			<MemoizedHeadCell key={id} {...{column, id, getContext, ...props}} isSorted={column.getIsSorted()} />
		)
	})
} 



const HeadCell = ({ column, id, getContext, headerOrFooterKey, columnWidth, tableStyle }: HeadCellProps) => {
		const positionStyle = headerOrFooterKey === "footer" ? {bottom: 0} : {top: 0};
		return (
			<div key={id} style={{zIndex: 100, ...getFrozenColumnStyle(column.getIsPinned(), false, false, column.getIndex(), columnWidth.length, true, tableStyle, pinnedWidthOffset(column.getIsPinned(), columnWidth, column.getIndex())), position: "sticky", ...positionStyle}}>				
				{flexRender(column.columnDef[headerOrFooterKey], getContext())}
			</div>
		)
}

const MemoizedHeadCell = memo(HeadCell, (previousProps, newProps) => {
	if (newProps.column.columnDef.meta?.forceRerenderOnTableEdit) {
		return false;
	}
	if (previousProps.loading !== newProps.loading) {
		return false;
	}
	if (previousProps.tableToggle !== newProps.tableToggle) {
		return false;
	}
	if (previousProps.isSorted !== newProps.isSorted) {
		return false;
	}
	return true;
})